import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=b4e80f46&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"
import style0 from "./foot.vue?vue&type=style&index=0&id=b4e80f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e80f46",
  null
  
)

export default component.exports